import { Component, Input, OnInit } from '@angular/core';
import { Constants } from 'src/app/utils/constants';
import { IOrderTaskPost, Page, OrderTaskPostService } from 'src/app/xena-api';

@Component({
    selector: 'app-cost-post-list',
    templateUrl: './cost-post-list.component.html',
    styleUrls: ['./cost-post-list.component.scss'],
    standalone: false
})
export class CostPostListComponent implements OnInit {

  _pageIndex = 0;
  _pageSize = 10;
  page: Page<IOrderTaskPost>;
  @Input() voucherId: number = 0;

  get pageSize() {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
    this.load();
  }

  get pageIndex() {
    return this._pageIndex;
  }

  getApprovedNames(orderTaskPost: IOrderTaskPost): string[] {
    var approvers: string[] = [];
    if(orderTaskPost.approvedByName != null){
      approvers.push(orderTaskPost.approvedByName);
    }
    if(orderTaskPost.approvedBySecondaryName != null){
      approvers.push(orderTaskPost.approvedBySecondaryName);
    }
    return approvers;
  }

  approvedNamesTooltip(orderTaskPost: IOrderTaskPost): string {
    return this.getApprovedNames(orderTaskPost).join(', ');
  }

  set pageIndex(value: number) {
    this._pageIndex = value;
    this.load();
  }

  get pages() {
    if (this.page) {
      return Math.ceil(this.page.count / this.pageSize);
    } else {
      return 1;
    }
  }

  get totalEntities() {
    return this.page != null ? this.page.count : 0;
  }


  constructor(private orderTaskPostService: OrderTaskPostService) { }


  ngOnInit(): void {
    this.load();
  }


  private load() {
    this.orderTaskPostService.list({
      forceNoPaging: false,
      pageSize: this.pageSize,
      page: this.pageIndex,
      voucherId: this.voucherId,
      dateFrom: 0,

      // Setting this far-into-the-future-date is a hack in order to comply with a broken endpoint design.
      // Will hopefully be fixed with https://jira.eg.dk/projects/XNA/issues/XNA-7027
      dateTo: Constants.FISCAL_DATE_YEAR_2100
    }).subscribe(page => this.page = page);
  }
}
